import React from 'react';
import {IMultiSelectProps, ISelectProps, MultiSelectInput, SelectInput} from '~/components/Controls/Select';
import {TableSortDirection} from '~/components/Table';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {sortByString} from '~/lib/sort';
import {fetchCategories} from '~/modules/Clients/api';

type ISelectIABCategoriesProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectIABCategories = ({
    disabled,
    ...props
}: ISelectIABCategoriesProps) => {
    const {resource, isPending} = useResource(() => fetchCategories(), []);

    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={resource.map(iab => ({
            label: iab.description,
            value: iab.id
        }))}/>;
};

type IMultiSelectIABCategoriesProps = Omit<IMultiSelectProps<ID>, 'items'>;

export const MultiSelectIABCategories = ({
    disabled,
    ...props
}: IMultiSelectIABCategoriesProps) => {
    const {resource, isPending} = useResource(() => fetchCategories(), []);
    return <MultiSelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={resource.map(iab => ({
            label: iab.description,
            value: iab.id
        }))}/>;
};
